const $header = $('.masthead'),
    $footer = $('.site-footer'),
    $button = $('.mobile-overlay-button'),
    classButtonVisible = 'mobile-overlay-button--visible';

let $inviewElem = $('.' + $button.data('hide-inview-class')),
    hideWhenInview = false,
    inview = false;

if ($inviewElem.length > 0) {
    hideWhenInview = true;
}

$(window).on('scroll', function () {
    if (viewport().width < 768) {
        let scrolledDistance = $(document).scrollTop(),
            showTrigger = 0, // viewport().height / 2,
            hideTrigger = $(document).outerHeight() - ($footer.outerHeight() / 2) - viewport().height;

        if (hideWhenInview) {
            // check if element is in viewport
            let inviewStart = $inviewElem.offset().top - viewport().height,
                inviewEnd = $inviewElem.offset().top + $inviewElem.outerHeight();

            inview = scrolledDistance > inviewStart && scrolledDistance < inviewEnd;
        }

        if (scrolledDistance > showTrigger && scrolledDistance < hideTrigger && !inview) {
            if (!$button.hasClass(classButtonVisible)) {
                $button.addClass(classButtonVisible);
            }
        } else {
            if ($button.hasClass(classButtonVisible)) {
                $button.removeClass(classButtonVisible);
            }
        }
    }
});